/**
 * p05002専用メソッド 
 */

// Vue
import router from '@/router';

// axios
import axios from "axios";

// moment
import moment from 'moment';

// メモった！、キニッタ！共通
import * as JC from '@/components/00/JsonContainer';    // 通信用Jsonコンテナ
import * as GVar from '@/components/00/Var00';          // 共通変数
import * as GFunc from '@/components/00/Common00';    // 共通メソッド
import * as Tools from '@/components/00/Tools';         // 共通ツール

// キニッタ！専用
import * as LVar from '@/components/05/Var05002';                   // キニッタ！専用変数
import * as Const05 from '@/components/05/properties/Const05';
import * as Msg05Ja from '@/components/05/properties/Message05002_ja';
import * as LFunc from '@/components/05/Common05002'; // キニッタ！専用メソッド

/**
 * 画面表示などに使うツールを定義する
 */

//=================================================================
// 起動時スクリプト
//=================================================================

/**
 * ユーザー情報の読み込み（ログイン処理）
 * サーブレットとの通信が成功した場合、ユーザー情報(M109003JC)がJSON形式で返される。
 * ログイン可否の判断はsttsCdで行う。(0:ログイン済み,0以外：ログインエラー)
 * 
 * @param shpId 店舗ID
 * @param usrNm ユーザー名
 * @param pwd パスワード
 * @param lang 画面表示用言語コード(ja,...)
 * @param ttype(1:Android, 2:iOS、P:PC)
 * @return なし
*/
export const getUserInfo =
async function (shpId: number, usrNm: string, pwd: string, lang: string, ttype: string)
{
    if ( GFunc.isDebugEnabled() ) {console.log("getUserInfo()");}
        JC.setCommonHeader(new JC.CommonHeader(0, pwd, GVar.langCd, GVar.countryCd, GVar.ttype, GVar.sysCd, GVar.tmpltCd));
        
        // パラメーターセット
        JC.commonHeader.actionFlag = "C";

        const c050150JC = new JC.C050150JC();
        c050150JC.mpt003.cnctMtd = LFunc.getProperty("CONNECT_METHOD.WEB")!; // 接続方式
        c050150JC.mpt003.sysCd = GVar.sysCd;        // システムコード
        c050150JC.mpt003.tmpltCd = GVar.tmpltCd;    // テンプレートコード
        c050150JC.mpt003.trmnlTyp = GVar.ttype;     // 接続端末
        c050150JC.shpId = shpId;                  // 店舗ID
        c050150JC.exstOrgUsrNm = usrNm;           // ログインユーザー名

        // 検索処理を呼び出す
        await axios.post(GVar.getServerUrl2()+"/c050150", 
        JC.toJson(c050150JC),
        {headers: {"content-type": "application/json"}})
        .then(function (response) 
        {
            if ( GFunc.isDebugEnabled() ) { console.log(response); }
            const rtnUi = response.data;
            const ui = JSON.stringify(rtnUi);
            GFunc.setServerSttsCd(rtnUi.sttsCd);
             // ステータスチェック
             if ( rtnUi.sttsCd != getProperty("JSON.STATUS.OK") )
             {
                //
                // ログイン失敗
                //
                console.error("ログイン失敗 stts="+rtnUi.sttsCd+", msg="+rtnUi.msg);
                GFunc.setLoggedin(false);
                // エラーの内容でユーザー情報を保存する
                sessionStorage.setItem(GFunc.getUiKey(),ui);
                GFunc.setUi(rtnUi);
                GFunc.setServerMsg(decodeURI(rtnUi.msg));
             }
             else
             {
                //
                // ログイン完了
                //
    
                // 保存してある古いユーザー情報を全てクリアする
                GFunc.clearUserData();
                GFunc.setLoggedin(true);
                // ユーザー情報をsessionstorageに保存
                sessionStorage.setItem(GFunc.getUiKey(),ui);
                GFunc.setUi(rtnUi.result);
                GVar.setLangCd(rtnUi.result.lang);
                // 取得したuidをユーザー情報をJson用共通ヘッダーにセット
                JC.commonHeader.uid = rtnUi.result.uid.value;
                GFunc.setServerMsg("");
                // カレント年月日を設定
                GFunc.setCurYYYYMMDD(Tools.getCurrentYyyymmdd());
             }
        })
        .catch(function (error) 
        {
            // ネットワークエラー
            GFunc.writeAxiosErrorLog(error);
            console.error("ネットワークエラー:"+GVar.getServerUrl2());
            GFunc.setServerSttsCd("");
            GFunc.setLoggedin(false);
            //setServerMsg(getProperty("msg.1001")+"["+getServerUrl()+"]");
            GFunc.setServerMsg(getProperty("msg.1001")
            +"["+GVar.getServerUrl2()+"], "
            +"["+error.response.data+"], "
            +"["+error.response.status+"], "      // 例：400
            +"["+error.response.statusText+"], "  // Bad Request
            +"["+error.response.headers+"]"
            );
    
        })
        // .finally(function () {
            // Waiting画像を消す
            // GFunc.removeWaiting();
        //})
        ;
}

/**
 * ログイン後、トップページを開く前に行う処理（トップページを決定する）
 * @ returns true - 利用権限あり、 false - 利用権限なし
 */
export async function afterLogin()
{
    if ( GFunc.isDebugEnabled() ) {console.log("afterLogin()");}
    // 変数の初期化
    LVar.reInitLocalVars();
    GVar.setRegisteredEmail("");
    newDay();
    // 店舗グループ一覧取得
    await getMyShopGroupList();
    // 店舗グループ一覧をロード済みにする
    LVar.setShpGrp_loaded(true);
    if ( LVar.c050100Keep.results != null && LVar.c050100Keep.results.length > 0 )
    {
        if ( LVar.c050100Keep.results.length == 1 )
        {
            // 店舗グループが1件なので当該店舗グループの店舗一覧を取得する
            LVar.setC050100KeepIdx(0);
            LVar.setSCurShpGrpId(LVar.c050100Keep.results[0].shpGrpId); // １件なので先頭の店舗グループIDをセット
            await getMyShopList();
            if ( LVar.c050070Keep.results != null)
            {
                if ( LVar.c050070Keep.results.length == 1 )
                {
                    // 店舗が1件なので店舗トップに遷移
                    LVar.setC050070KeepIdx(0);
                    LVar.setSCurShpId(LVar.c050070Keep.results[0].mpt151.shpId); // １件なので先頭の店舗IDをセット
                    GVar.setCurPrjNo(LVar.c050070Keep.results[0].mpt007.prjNo);  // １件なので先頭店舗のプロジェクトNo.をセット
                    GVar.setCurPage("S05002002");
                }
                else if ( LVar.c050070Keep.results.length > 1 )
                {
                    // 店舗が複数あるのでグループ管理に遷移
                    GVar.setCurPage("S05002015");
                }
            }
            else
            {
                // 店舗を所有してないので利用できない
                alert(LFunc.getProperty("msg.0034"));
                GVar.setCurPage("s05002000");
                return false;
            }

        }
        else if ( LVar.c050100Keep.results.length > 1 )
        {
            // 店舗グループが複数あるので店舗グループ一覧に遷移
            GVar.setCurPage("S05002014");
        }
    }
    else
    {
        // 店舗を所有してないので利用できない
        alert(LFunc.getProperty("msg.0034"));
        GVar.setCurPage("s05002000");
        return false;
    }   
    return true;
}

//=================================================================
// プロパティー用スクリプト
//=================================================================

/**
 * プロパティーの値を返す
 * 
 * @param key キー
 * @param 置換文字列(可変パラメーター)
 * @returns 値
 */
export function getProperty (key: string, ...reps: string[])
{
    let str = null;
    // メモった！、キニッタ！共通プロパティーを検索
    if ( null == (str = GFunc.getProperty(key)) )
    {
        // 見つからなければキニッタ！用Constを検索
        if ( null == (str = Const05.map.get(key)) )
        {
            // 見つからなければキニッタ！用メッセージを検索
            str = Msg05Ja.map.get(key);
        }
    }
    if ( str != null )
    {
        // メッセージの場合、文字列の置き換えを行う
        reps.forEach( function(item, index)
        {
            str = eval("str.replace(/\\{\\$"+(index+1)+"\\}/g, item)");
        });
    }
    return str;
}

//=================================================================
// ページ制御用スクリプト
//=================================================================

/**
 * ログアウト処理
 */
export function logout()
{
    console.debug("logout()");
    GFunc.setLoggedin(false);
    // local storageからパスワードを削除する
    const ui = GFunc.getUi();
    if ( !(typeof ui === "undefined") && ui != null )
    {
        // ユーザー情報をクリア
        ui.pwd = "";
        GFunc.clearUserData();
        // GFunc.setUi(ui);
        GVar.setLangCd(ui.lang);
    }
    // ログイン画面へ遷移する
    router.replace({name: GVar.topPage});
}

//=================================================================
// チェック用スクリプト
//=================================================================

// 日付大小チェック ymd1 <= ymd2
// 引数ymd1, ymd2はYYYY/MM/DD形式
export function isValidYmdRange(ymd1: string, ymd2: string)
{
	if (ymd1.replace(/\//g,"" ) > ymd2.replace(/\//g,"" ))
	{
		return false;
	}
	return true;
}

//=================================================================
// 地図用スクリプト
//=================================================================

/**
 * 地図表示用住所を編集して返す
 * @param mpt151 店舗情報
 */
export function getMapAddr(mpt151: any)
{
    if ( GFunc.isDebugEnabled() ) {console.log("getMapAddr()");}
    let addr = "";
    if ( mpt151.shpPstCd != null ) // 郵便番号
    {
        addr = mpt151.shpPstCd;
    }
    if ( addr != "" ) { addr += " ";}
    if ( mpt151.shpAddr != null ) // 住所
    {
        addr += mpt151.shpAddr;
    }
    return addr;
}

/**
 * 地図に表示されるポップアップの内容を編集して返す
 * @param mpt151 店舗情報
 */
export function getMapDesc(mpt151: any)
{
    if ( GFunc.isDebugEnabled() ) {console.log("getMapDesc()");}
    let desc = "";
    if ( mpt151.shpPstCd != null ) // 郵便番号
    {
        desc = "<div style='text-align: left;'><span class='map_shopInfo'>"+mpt151.shpPstCd+"</span></div>";
    }
    if ( mpt151.shpAddr != null ) // 住所
    {
        desc += "<div style='text-align: left;'><span class='map_shopInfo'>"+mpt151.shpAddr+"</span></div>";
    }
    if ( desc != "" )
    {
        // 説明を組み立てる
        desc = "<div style='text-align: center;'><span class='map_shopName'>"+mpt151.shpNm+"</span></div>"  // 店舗名
                 + desc;                // 住所
        if ( mpt151.shpPhnNo != null ) // 電話番号
        {
            desc += "<div style='text-align: left;'><span class='map_shopInfo'>"+mpt151.shpPhnNo+"</span></div>";
        }
        desc += "</div>";
    }
    return desc;
}

//=================================================================
// その他
//=================================================================

/**
 * 接続情報登録
 * サーバー側で接続可否を判断する
 *
 * @return true - 接続OK、 false - 接続NG
 */
export async function saveConnectInfo()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("saveConnectInfo()");}
    // let stts = false;
    // パラメーターセット
    const c000190JC = new JC.C000190JC();
    c000190JC.mpt003.cnctMtd = getProperty("CONNECT_METHOD.WEB")!; // 接続方式
    c000190JC.mpt003.sysCd = GVar.sysCd;            // システムコード
    c000190JC.mpt003.tmpltCd = GVar.tmpltCd;        // テンプレートコード
    c000190JC.mpt003.trmnlTyp = GVar.ttype;         // 接続端末
    await axios.post(GVar.getServerUrl2()+"/c000190", 
        JSON.stringify(c000190JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd != getProperty("JSON.STATUS.OK") )
        {
            // stts = true;
            alert(rtn.msg); // エラー
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        alert(GFunc.getProperty("msg.1001"));
        router.push({name: GVar.topPage});
    })
}

/**
 * 感染対策達成度を表示用の達成度に変換する
 * @param scr 感染対策達成度
 * @return 表示用達成度
 */
export function convAchivementScore(scr: number)
{
        let achievementScr = "0.0";
        if ( scr == null ) { return(achievementScr); }
        if ( scr > 4.5 ){ achievementScr = "5.0"; }
        else if ( scr > 4.0 ){ achievementScr = "4.5"; }
        else if ( scr > 3.5 ){ achievementScr = "4.0"; }
        else if ( scr > 3.0 ){ achievementScr = "3.5"; }
        else if ( scr > 2.5 ){ achievementScr = "3.0"; }
        else if ( scr > 2.0 ){ achievementScr = "2.5"; }
        else if ( scr > 1.5 ){ achievementScr = "2.0"; }
        else if ( scr > 1.0 ){ achievementScr = "1.5"; }
        else if ( scr > 0.5 ){ achievementScr = "1.0"; }
        else if ( scr > 0.1 ){ achievementScr = "0.5"; }
        return(achievementScr);
}

/**
 * 店舗一覧取得
 */
export async function getMyShopList()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getMyShopList()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050070JC = new JC.C050070JC();
    c050070JC.sysCd = GVar.sysCd;        // システムコード
    c050070JC.tmpltCd = '001';    // テンプレートコード001固定
    c050070JC.shpGrpId = LVar.sCurShpGrpId; // 店舗グループID
    c050070JC.memUid = GFunc.getUi().uid.value; // ユーザーID
    // 役割コードは所有者、管理者、スタッフを指定する
    c050070JC.addRllCds(GFunc.getProperty("roll.owner"));
    c050070JC.addRllCds(GFunc.getProperty("roll.manager"));
    c050070JC.addRllCds(GFunc.getProperty("roll.staff"));
    await axios.post(GVar.getServerUrl2()+"/c050070", 
    JC.toJson(c050070JC),
    {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
        {
			// 店舗一覧を退避
			LVar.setC050070Keep(rtn);
        }
        else
        {
            // エラー
            alert(rtn.msg);
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        alert(GFunc.getProperty("msg.1001"));
    })
    ;
}


/**
 * ログインユーザーが店舗所有者又は管理者かを返す
 * @return true - 店舗所有者又は管理者、false - 店舗所有者又は管理者以外
 */
export function hasShops()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("hasShops()");}
    if ( LVar.c050070Keep.results != null && LVar.c050070Keep.results.length > 0 )
    {
        return true;
    }
    else { return false; }
}

/**
 * 特定店舗情報を取得する（一般利用モード用）
 *
 * @param shpId 店舗ID
 */
export async function getShop(shpId: any)
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getShop()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050010JC = new JC.C050010JC();
    c050010JC.sysCd = GVar.sysCd;        // システムコード
    c050010JC.tmpltCd = '001';    // テンプレートコード001固定
    c050010JC.addShpId(shpId);      // 店舗ID
    await axios.post(GVar.getServerUrl2()+"/c050010",
        JC.toJson(c050010JC),
        {headers: {"content-type": "application/json"}})
        .then( response =>
        {
            if ( GFunc.isDebugEnabled() ) { console.log(response); }
            const rtn = response.data;
            LVar.setC050010Keep(rtn);
        })
        .catch(err =>
        {
          // ネットワークエラー
          alert(getProperty("msg.1001")+":"+err);
        })
        ;
}

/**
 * 特定店舗情報を取得する（一般利用モード用）
 *
 * @param evntNo イベントNo.
 */
export async function getShopByEventNo(evntNo: any)
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getShopByEventNo()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050080JC = new JC.C050080JC();
    c050080JC.sysCd = GVar.sysCd;        // システムコード
    c050080JC.tmpltCd = '001';    // テンプレートコード001固定
    c050080JC.evntNo = evntNo;      // イベントNo.  
    await axios.post(GVar.getServerUrl2()+"/c050080", 
    JC.toJson(c050080JC),
    {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
        {
            // 結果を退避
            LVar.setC050010Keep(rtn);
        }
        else
        {
            // エラー
            alert(rtn.msg);
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        alert(GFunc.getProperty("msg.1001"));
    })
    ;
}

/**
 * 現在選択中の店舗（プロジェクト）がプロジェクト有料オプションを持っているか確認する
 * この関数を呼ぶ前に必ずサーブレットc050070が呼ばれている事
 *
 * @param optCd オプションコード
 * @return ture - 保持している、 false - 保持してない
 */
export function hasOption(optCd: string)
{
    if ( LVar.c050070Keep == null || LVar.c050070Keep.results == null || LVar.c050070KeepIdx == null ) { return false; }
    if ( LVar.c050070Keep.results[LVar.c050070KeepIdx].options.includes(optCd) ) { return true; }
    else { return false; }
}

/**
 * 現在選択中の店舗（プロジェクト）がプロジェクト有料オプションを持っているか確認する
 * この関数を呼ぶ前に必ずサーブレットc050070が呼ばれている事
 *
 * @param optCd オプションコード
 * @return ture - 保持している、 false - 保持してない
 */
export function hasOptionByGroup(optCd: string)
{
    if ( LVar.c050070Keep == null || LVar.c050070Keep.results == null || LVar.c050070KeepIdx == null ) { return false; }
    for (let i = 0; i < LVar.c050070Keep.results.length; i++) {
        if ( LVar.c050070Keep.results[i].options.includes(optCd) ) { return true; }
    }
    return false; 
}

/**
 * 日付が変わった際の処理
 */
export function newDay()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("newDay()");}
    //  現在の日付を取得する
    const currentDate = new Date();
    // 同一日付で既にnewDayが実行されている場合は全てスキップする
    if ( GVar.minYYYYMM != "" && GVar.maxYYYYMM != "" && GVar.today != null && Tools.getYyyymmddFromDate(GVar.today) == Tools.getYyyymmddFromDate(currentDate) ) {return;}
	// 年月選択リスト作成
	// ユーザーオプションにより年月リストの範囲を決定する
    GVar.setToday(currentDate);
	// 開始、終了年月日を設定する
    const beginDate = new Date(currentDate);
    beginDate.setMonth(beginDate.getMonth()+Number(getProperty('s05001102.cal.months.past'))*-1); // 開始年月日
    GVar.setBeginDate(beginDate);
    GVar.setBeginDateISO(moment(beginDate).format('YYYY-MM-DDTHH:mm:ss'));
    const endDate = new Date(currentDate);
    endDate.setMonth(endDate.getMonth()+Number(getProperty('s05001102.cal.months.future'))); // 終了年月日
    GVar.setEndDate(endDate);
    GVar.setEndDateISO(moment(endDate).format('YYYY-MM-DDTHH:mm:ss'));
	// 最小、最大年月の設定
	GVar.setMinYYYYMM(Tools.getYyyymmFromDate(beginDate));
	GVar.setMaxYYYYMM(Tools.getYyyymmFromDate(endDate));
}

/**
 * お店ホームページへのURLを返す
 * @returns お店ホームページへのURL
 */
export function getShopHpUrl(shpId: any)
{
    return(GFunc.getProperty("dynamiclink.05001.02.homepage")!+GFunc.getProperty("dynamiclink.05001.02.param.shpid")+"="+ shpId);
}

/**
 * お店ホームページへのダイナミックリンクを返す
 * @returns お店ホームページへのダイナミックリンク
 */
export function getShopHpDl(shpId: any)
{
    return(
        // https://p05001.page.link/?link=
        GFunc.getProperty("dynamiclink.05001.02.1")!
        // https://www.esplanadeone.com/p05001/05/p/index.html?
        + GFunc.getProperty("dynamiclink.05001.02.2")
        // shpid
        + GFunc.getProperty("dynamiclink.05001.02.param.shpid") 
        + "="
        // 店舗ID
        + shpId
        // &apn=com.esplanadeone.p05001&isi=1583712947&ibi=com.esplanadeone.p05001
        + GFunc.getProperty("dynamiclink.05001.02.3")
    // 応援メッセージ
    );
}

/**
 * 店舗グループ一覧取得
 */
export async function getMyShopGroupList()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getMyShopGroupList()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050100JC = new JC.C050100JC();
    c050100JC.sysCd = GVar.sysCd;        // システムコード
    c050100JC.tmpltCd = '001';    // テンプレートコード001固定
    c050100JC.memUid = GFunc.getUi().uid.value; // ユーザーID
    // 役割コードは所有者、管理者、スタッフを指定する
    c050100JC.addRllCds(GFunc.getProperty("roll.owner"));
    c050100JC.addRllCds(GFunc.getProperty("roll.manager"));
    c050100JC.addRllCds(GFunc.getProperty("roll.staff"));
    
    // 検索処理を呼び出す
    await axios.post(GVar.getServerUrl2()+"/c050100", 
    JC.toJson(c050100JC),
    {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        LVar.setC050100Keep(rtn);
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        alert(GFunc.getProperty("msg.1001"));
    })
    ;
}

//=================================================================
// 再発行用スクリプト
//=================================================================

/**
 * 仮パスワードを発行する
 * @param email パスワード発行対象のメールアドレス
 */
export const renewPwd = async function (shpId: number, userNm: string)
{
    if ( GFunc.isDebugEnabled() ) {console.log("renewPwd()");}
    // 入力チェック
    if ( shpId == null || shpId == 0) 
    {
        alert(getProperty("msg.0267"));
        return;
    }
    if(userNm  == null || userNm.length == 0)
    {
        alert(getProperty("msg.0143"));
        return;
    }
    if ( GFunc.isDebugEnabled() ) {console.log("get()");}
    // パラメーターセット
    JC.setCommonHeader(new JC.CommonHeader(0, "Kagura", GVar.langCd, GVar.countryCd, GVar.ttype, GVar.sysCd, GVar.tmpltCd));
    // パラメーターセット
    JC.commonHeader.actionFlag = "U";

    const c050160JC = new JC.C050160JC();
    c050160JC.shpId = shpId;           // 店舗ID
    c050160JC.usrNm = userNm;           // ユーザー名
    c050160JC.mailTmpl = "0004";         // メールテンプレートファイル名

    // 検索処理を呼び出す
    await axios.post(GVar.getServerUrl2()+"/c050160", 
    JC.toJson(c050160JC),
    {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }

            //
            // パスワード変更完了
            //
            const rtn = response.data;
            alert(rtn.msg);
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        alert(GFunc.getProperty("msg.1001"));
    })
    ;
}